import React, { useCallback, useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

export function GenerateMoreDialog({
	visible,
	onHide,
	onGenerate,
}: {
	visible: boolean;
	onHide: () => void;
	onGenerate: (quantity: number) => Promise<void> | void;
}) {
	const [quantity, setQuantity] = useState<string>("1");

	useEffect(() => {
		if (!visible) setQuantity("1");
	}, [visible]);

	const handleGenerate = useCallback(() => {
		const qty = Number(quantity);
		onGenerate(qty);
	}, [onGenerate, quantity]);

	const footer = (
		<div>
			<Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
			<Button label="Generate" icon="pi pi-plus" onClick={handleGenerate} autoFocus />
		</div>
	);

	return (
		<Dialog
			header="Generate More QR Code URLs"
			visible={visible}
			style={{ width: "30rem" }}
			onHide={onHide}
			footer={footer}
		>
			<label htmlFor="quantity" className="block mb-2 text-lg ">
				Quantity
			</label>
			<InputText
				id="quantity"
				inputMode="numeric"
				className="block w-full"
				value={quantity}
				onChange={(e) => setQuantity(e.target.value.replace(/[^0-9]/g, ""))}
			/>
		</Dialog>
	);
}